import { render, staticRenderFns } from "./TermsOfServiceEN.vue?vue&type=template&id=7db03a96&"
import script from "./TermsOfServiceEN.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceEN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports